import axios from "axios";
import Cookies from "js-cookie";

import momentTimezone from "moment-timezone";
import { baseURL, handleDecrypt } from "../resources/utils/helper";
import store from "../store";
import { signOutRequest } from "../store/auth/authSlice";
import RenderToast from "../Components/atoms/RenderToast/RenderToast";

const getErrorMsg = (error = null) => {
  const message = error?.response?.data?.message;
  let errorMessage = "";

  if (Array.isArray(message)) {
    errorMessage = message[0];
  } else if (Array.isArray(message?.error) && message?.error[0]) {
    errorMessage = message?.error[0];
  } else {
    errorMessage = message;
  }

  return errorMessage;
};

let handleRequest = async ({
  method = "",
  route = "",
  data = {},
  headers = {},
  dispatch = null,
  showAlert = true,
  isFormData = false,
}) => {
  try {
    const url = baseURL(route);
    console.log("FINAL URL:", url);

    const token = Cookies.get("_xpdx");
    // ✅ Check Redux store as backup if cookie is missing
    const reduxState = store.getState();
    const reduxToken = reduxState?.authReducer?.accessToken;

    // ✅ Safe auth header handling
    let authHeader = {};

    const rawToken = token || reduxToken;

    if (rawToken && route !== "auth/admin/login") {
      let decryptedToken = "";
      if (typeof rawToken === "string" && rawToken.startsWith("eyJ")) {
        decryptedToken = rawToken;
      } else {
        try {
          decryptedToken = handleDecrypt(rawToken);
        } catch (_) {
          decryptedToken = "";
        }
      }

      if (!decryptedToken && typeof rawToken === "string" && rawToken.startsWith("eyJ")) {
        decryptedToken = rawToken;
      }

      if (decryptedToken) {
        authHeader = {
          Authorization: `Bearer ${decryptedToken}`,
        };
      }
    }

    const _headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      timezone: momentTimezone.tz.guess(),

      ...(isFormData && {
        "Content-Type": "multipart/form-data",
      }),

      ...authHeader,
      ...headers,
    };

    const response = await axios({
      method,
      url,
      data,
      headers: _headers,
    });

    return { response, error: null };
  } catch (error) {
    console.error("🔥 ACTUAL ERROR:", error);

    const errorMessage = getErrorMsg(error);

    if (showAlert) {
      RenderToast({
        type: "error",
        message: errorMessage || "An unexpected error occurred.",
        position: "top-center",
      });
    }

    if (error?.response?.status === 401) {
      Cookies.remove("_xpdx", { path: "/" });
      Cookies.remove("_xpdx_rf", { path: "/" });
      store.dispatch(signOutRequest());
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    return { response: null, error };
  }
};

const Get = ({
  route = "",
  headers = {},
  dispatch = null,
  showAlert = true,
}) => {
  return handleRequest({
    method: "get",
    route,
    headers,
    dispatch,
    showAlert,
  });
};

const Post = ({
  route = "",
  data = {},
  headers = {},
  showAlert = true,
  dispatch = null,
  isFormData = false,
}) => {
  return handleRequest({
    method: "post",
    route,
    data,
    headers,
    dispatch,
    showAlert,
    isFormData,
  });
};

const Patch = ({
  route = "",
  data = {},
  headers = {},
  showAlert = true,
  dispatch = null,
  isFormData = false,
}) => {
  return handleRequest({
    method: "patch",
    route,
    data,
    headers,
    dispatch,
    isFormData,
    showAlert,
  });
};

const Put = ({
  route = "",
  data = {},
  headers = {},
  showAlert = true,
  dispatch = null,
  isFormData = false,
}) => {
  return handleRequest({
    method: "put",
    route,
    data,
    headers,
    dispatch,
    showAlert,
    isFormData,
  });
};

const Delete = ({
  route = "",
  headers = {},
  dispatch = null,
  showAlert = true,
}) => {
  return handleRequest({
    method: "delete",
    route,
    // data,
    headers,
    dispatch,
    showAlert,
  });
};

export { Delete, Get, Patch, Post, Put };
